






































import { BFormInput } from 'bootstrap-vue';

import ZenButton from '@reciprocity/button';

export default {
  name: 'ZenSearch',
  components: {
    BFormInput,
    ZenButton,
  },
  model: {
    prop: 'value',
    event: 'update',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideSearchIcon: {
      type: Boolean,
      default: false,
    },
    // If input should be focused when rendered
    focus: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showReset(): boolean {
      return !this.disabled && this.value.length > 0;
    },
  },
  mounted() {
    if (this.focus) {
      this.focusInput();
    }
  },
  methods: {
    reset(): void {
      this.focusInput();

      this.$emit('update', '');
      this.$emit('reset');
    },
    input(value: string): void {
      this.$emit('update', value);
    },
    focusInput(): void {
      this.$refs.input.focus();
    },
  },
};
